import { Center, Text } from "@chakra-ui/react"
import * as React from "react"
import { useQuery } from "react-query"

import { Loading } from "../Loading"
import { ProviderProps } from "./types"

interface FeatFlags {
  live_chase: {
    visible: boolean
  }
  proximity_search: {
    visible: boolean
  }
  multi_org: {
    visible: boolean
  }
  tags: {
    visible: boolean
  }
  bike_sn_as_name_extension: {
    visible: boolean
  }
  bike_admin_features: {
    visible: boolean
  }
  google_maps: {
    visible: boolean
  }
  asset_deployed_state: {
    visible: boolean
  }
}

const defaultFlags = {
  live_chase: {
    visible: false,
  },
  proximity_search: {
    visible: false,
  },
  multi_org: {
    visible: false,
  },
  tags: {
    visible: false,
  },
  bike_sn_as_name_extension: {
    visible: false,
  },
  bike_admin_features: {
    visible: false,
  },
  google_maps: {
    visible: false,
  },
  asset_deployed_state: {
    visible: false,
  },
}

export const FeatFlagsProvider: React.FC<ProviderProps> = ({ children }) => {
  const { data, isLoading } = useQuery<FeatFlags, string>("features-flags/rules-access", {
    staleTime: Infinity,
  })

  if (isLoading && !data) return <Loading />
  if (!data)
    return (
      <Center w="100vw" h="100vh">
        <Text>Error, please refresh</Text>
      </Center>
    )
  const value = data.live_chase ? data : defaultFlags
  return <FeatFlagsContext.Provider value={value}>{children}</FeatFlagsContext.Provider>
}

export const FeatFlagsContext = React.createContext<FeatFlags | undefined>(undefined)

export function useFeatFlags() {
  const context = React.useContext(FeatFlagsContext)
  if (!context) throw new Error("Must be called under FeatFlagsProvider")
  return context
}
